import React, {PureComponent as Component} from 'react';
import ContentLoader from 'react-content-loader'

import InputText from "../../../ui/template/Input/InputText";
import profile from "./Api/Profile";
import FormManager from "../../../ui/template/Form/FormManager";
import Field from "../../../ui/template/Form/Field";
import getProfile from "./Api/getProfile";
import Submit from "../../../ui/template/Form/Submit";
import Alerts from "../../../ui/template/Alert/Alerts";
import {MCbrowser} from "../../Context/browserContext";
import DatePicker from "../../../ui/template/Date/DatePicker";
import Interface from "../../../ui/template/Interface";
import PropTypes from "prop-types";


class EditProfile extends Component{

    constructor(props) {
        super(props);

        this.handleFirstNameChange = this.firstNameChange.bind(this);
        this.handleLastNameChange = this.lastNameChange.bind(this);
        this.HusernameChange = this.usernameChange.bind(this);
        this.handlEmailChange = this.emailChange.bind(this);
        this.HnationalCodeChange = this.nationalCodeChange.bind(this);
        this.HaddressChange = this.addressChange.bind(this);
        this.HbirthDateChange = this.birthDateChange.bind(this);
        this.HjobChange = this.jobChange.bind(this);
        this.HjobaddressChange = this.jobaddressChange.bind(this);


        this.handlePostUp = this.postUp.bind(this);
        this.state = {isload: false, isClose: false};
        this.values = {  firstName: '',lastName: '',username:"", email: '', nationalCode: '', address: '',birthDate:"", job:"" , jobaddress:""};
        this.form1=React.createRef();
        this.formAlerts=React.createRef();
        this.getLoadForm = this.getLoad.bind(this);
        this.components= {
            firstName: React.createRef(),
            lastName: React.createRef(),
            email: React.createRef(),
            nationalCode: React.createRef(),
            address: React.createRef(),
            job: React.createRef(),
            jobaddress: React.createRef(),
            username: React.createRef(),
        };
        this.birthDate= React.createRef();
        this.props=props;
    }

    usernameChange(e) {
        this.values.username= e.target.value;
        return true;
    }

    jobChange(e) {
        this.values.job= e.target.value;
        return true;
    }

    jobaddressChange(e) {
        this.values.jobaddress= e.target.value;
        return true;
    }

    firstNameChange(e) {
        this.values.firstName= e.target.value;
        return true;
    }

    lastNameChange(e) {
        this.values.lastName= e.target.value;
        return true;
    }

    emailChange(e) {
        this.values.email= e.target.value;
        return true;
    }

    nationalCodeChange(e) {
        this.values.nationalCode= e.target.value;
        return true;
    }

    addressChange(e) {
        this.values.address= e.target.value;
        return true;
    }

    birthDateChange(val) {
        this.values.birthDate=   val;
        return true;
    }

    async postUp() {
        let pageAlerts = this.context.page.pageAlerts;
        let l=await profile(this.values.firstName,this.values.lastName,this.values.username,
            this.values.email,this.values.nationalCode,this.values.address,
            this.values.birthDate,this.values.job,this.values.jobaddress ,pageAlerts,this.formAlerts);
        if(l===true){

        }
    }

    async getLoad() {
        let data=await getProfile();
        if(data===false){
            this.setState({isloadData:true});
        }else{
            let components=this.components;
            this.setState({isload: true, isClose: false});

            if(data.firstName!=null) this.values.firstName = data.firstName;
            if(data.lastName!=null) this.values.lastName = data.lastName;
            if(data.username!=null) this.values.username = data.username;
            if(data.email!=null) this.values.email = data.email;
            if(data.nationalCode!=null) this.values.nationalCode = data.nationalCode;
            if(data.address!=null) this.values.address = data.address;
            if(data.job!=null) this.values.job = data.job;
            if(data.jobaddress!=null) this.values.jobaddress = data.jobaddress;

            let d1 = data.birthAt;
            if (!Interface.isEmptyString(d1)) {
                this.birthDate.current.setDateTimeValue(d1);
                this.values.birthDate = this.birthDate.current.getValue();
            }

            Object.keys(this.components).forEach(element => {
                if (data.hasOwnProperty(element)) {
                    if(data[element]!=null) components[element].current.setValue(data[element]);
                }
            });
        }
    }

    componentDidMount(){
        this.getLoadForm();
    }

    render() {
        if (this.state.isload) {
            let c="";
            if(this.props.isSticky) c="side-sticky";
            return ( <FormManager className={c} ref={this.form1} submit={this.handlePostUp}>
                <div className="border rounded bg-white mb-3 rtl">
                    <div className="box-title border-bottom p-3">
                        <h6 className="m-0">
                            ویرایش اطلاعات
                        </h6>
                        <p className="mb-0 mt-0 small">
                            لطفا
                            اطلاعات خود را صحیح وارد نمائید. ممنون.
                        </p>
                    </div>
                    <div className="box-body p-3">
                        <div className="js-validate" noValidate="novalidate">
                            <div className="row">
                                <div className="col-sm-6 mb-2">
                                    <Field   keyState="firstName">
                                        <div className="js-form-message">
                                            <label id="nameLabel" className="form-label">
                                                نام
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="form-group">
                                                <InputText className="form-control" ref={this.components.firstName}  onChange={this.handleFirstNameChange}  />
                                                <small className="form-text text-muted">
                                                    مشخصات شما
                                                    برای دیگران نمایش داده نمی شود
                                                </small>
                                            </div>
                                        </div>
                                    </Field>
                                </div>
                                <div className="col-sm-6 mb-2">
                                    <Field   keyState="firstName">
                                        <div className="js-form-message">
                                            <label id="nameLabel" className="form-label">
                                                نام خانوادگی
                                                <span className="text-danger">*</span>
                                            </label>
                                            <div className="form-group">
                                                <InputText className="form-control" ref={this.components.lastName}   onChange={this.handleLastNameChange}  />
                                            </div>
                                        </div>
                                    </Field>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-2">
                                    <div className="js-form-message">
                                        <label id="usernameLabel" className="form-label">
                                            تاریخ تولد
                                        </label>
                                        <div className="form-group">
                                            <DatePicker containerClassName="w-100"  className="form-control"  onChange={this.HbirthDateChange} ref={this.birthDate}  />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 mb-2">
                                    <div className="js-form-message">
                                        <label id="usernameLabel" className="form-label">
                                            نام کاربری
                                            <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-group">
                                            <InputText className="form-control" ref={this.components.username}   onChange={this.HusernameChange}  />

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-2">
                                    <div className="js-form-message">
                                        <label id="emailLabel" className="form-label">
                                            ایمیل
                                            <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-group">
                                            <InputText className="form-control"  ref={this.components.email}  onChange={this.handlEmailChange}  />
                                            <small className="form-text text-muted">
                                                ایمیل شما جایی نمایش داده نمی شود
                                            </small>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 mb-2">
                                    <div className="js-form-message">
                                        <label id="emailLabel" className="form-label">
                                            کد ملی
                                            <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-group">
                                            <InputText className="form-control"  ref={this.components.nationalCode}  onChange={this.HnationalCodeChange}  />
                                            <small className="form-text text-muted">
                                                کد ملی شما جایی نمایش داده نمی شود
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 mb-2">
                                    <div className="js-form-message">
                                        <label id="locationLabel" className="form-label">
                                            آدرس
                                            <span className="text-danger">*</span>
                                        </label>
                                        <div className="form-group">
                                            <InputText className="form-control" ref={this.components.address}  onChange={this.HaddressChange}  />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-2">
                                    <div className="js-form-message">
                                        <label id="organizationLabel" className="form-label">
                                            شغل
                                        </label>
                                        <div className="form-group">
                                            <InputText className="form-control"  ref={this.components.job}  onChange={this.HjobChange}  />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 mb-2">
                                    <div className="js-form-message">
                                        <label id="organizationLabel" className="form-label">
                                            آدرس  محل کار
                                        </label>
                                        <div className="form-group">
                                            <InputText className="form-control"  ref={this.components.jobaddress}  onChange={this.HjobaddressChange}  />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-6 mb-2">
                                    <Alerts layout="relative" ref={this.formAlerts} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mb-3 text-right rtl">
                    <button type="reset" className="font-weight-bold btn btn-link rounded p-3" href="#"> &nbsp;&nbsp;&nbsp;&nbsp;
                        لغو
                        &nbsp;&nbsp;&nbsp;&nbsp; </button>
                    <Submit className="font-weight-bold btn btn-primary rounded p-3">
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        ذخیره تغییرات
                        &nbsp;&nbsp;&nbsp;&nbsp;
                    </Submit>
                </div>
        </FormManager>);
        }else{
            return ( <div className="border rounded bg-white mb-3 rtl">
                                <div className="box-title border-bottom p-3">
                                    <h6 className="m-0">
                                        ویرایش اطلاعات
                                    </h6>
                                </div>
                                <div className="box-body p-3">
                                    <ContentLoader width="100%" height="300px">

                <rect x="10%" y="20" rx="5" ry="5" width="55%" height="30" />
                <rect x="75%" y="20" rx="5" ry="5" width="23%" height="30" />

                <rect x="10%" y="70" rx="5" ry="5" width="55%" height="30" />
                <rect x="75%" y="70" rx="5" ry="5" width="23%" height="30" />

                <rect x="10%" y="120" rx="5" ry="5" width="55%" height="30" />
                <rect x="75%" y="120" rx="5" ry="5" width="23%" height="30" />

                <rect x="10%" y="170" rx="5" ry="5" width="55%" height="30" />
                <rect x="75%" y="170" rx="5" ry="5" width="23%" height="30" />

                <rect x="10%" y="220" rx="5" ry="5" width="55%" height="30" />
                <rect x="75%" y="220" rx="5" ry="5" width="23%" height="30" />

                <rect x="10%" y="270" rx="5" ry="5" width="55%" height="30" />
                <rect x="75%" y="270" rx="5" ry="5" width="23%" height="30" />

            </ContentLoader>
                                </div>
                            </div> );
        }
    }
}

EditProfile.contextType = MCbrowser;

EditProfile.propTypes = {
    isSticky: PropTypes.bool,
};

EditProfile.defaultProps = {
    isSticky:false
};

export default EditProfile;
